<template>
    <div id="unmark">
        <div class="unmark-container">
            <div class="unmark-main">
                <div class="page-header">
                    <div class="eyebrow">客服中心 · 号码安全</div>
                    <div class="h1-wrap">
                        <div class="h1-icon">✕</div>
                        <h1>取消号码标记</h1>
                    </div>
                    <p class="lede">如果您的号码被误标记，请通过以下任一第三方平台提交申诉。我们建议优先在线申诉，流程更快捷。</p>
                </div>

                <div class="section-title">
                    <h2>第三方申诉平台</h2>
                    <div class="meta">共 5 个渠道</div>
                </div>

                <div class="providers">
                    <div class="provider">
                        <div class="provider-icon icon-360">360</div>
                        <div class="provider-info">
                            <div class="provider-name">360 手机卫士</div>
                            <div class="provider-phone">010-58781000</div>
                        </div>
                        <a href="http://haomashensu.360.cn/index.html" target="_blank" class="provider-link">前往 ›</a>
                    </div>

                    <div class="provider">
                        <div class="provider-icon icon-cb">电</div>
                        <div class="provider-info">
                            <div class="provider-name">电话邦</div>
                            <div class="provider-phone">400 061 8800</div>
                        </div>
                        <a href="http://www.dianhua.cn/appeal" target="_blank" class="provider-link">前往 ›</a>
                    </div>

                    <div class="provider">
                        <div class="provider-icon icon-td">熊</div>
                        <div class="provider-info">
                            <div class="provider-name">泰迪熊移动</div>
                            <div class="provider-phone">010-53821804</div>
                        </div>
                        <a href="https://www.teddymobile.cn/numberComplain" target="_blank" class="provider-link">前往 ›</a>
                    </div>

                    <div class="provider">
                        <div class="provider-icon icon-tx">企</div>
                        <div class="provider-info">
                            <div class="provider-name">腾讯手机管家</div>
                            <div class="provider-phone">4006 700 700</div>
                        </div>
                        <a href="https://yun.m.qq.com/content.html#1" target="_blank" class="provider-link">前往 ›</a>
                    </div>

                    <div class="provider">
                        <div class="provider-icon icon-bd">百</div>
                        <div class="provider-info">
                            <div class="provider-name">百度手机卫士</div>
                            <div class="provider-phone">400-921-3900</div>
                        </div>
                        <a href="https://haoma.baidu.com/person/complaint" target="_blank" class="provider-link">前往 ›</a>
                    </div>
                </div>

                <div class="featured">
                    <div class="featured-header">
                        <div class="featured-icon">阿</div>
                        <div class="featured-title">阿里钱盾</div>
                    </div>
                    <p class="featured-subtitle">钱盾号码标记申诉渠道现改为手机淘宝安全中心，具体操作流程如下：</p>

                    <div class="steps">
                        <div class="step" v-for="(v, i) in processArr" :key="i">
                            <div class="step-num">{{ v.num }}</div>
                            <div class="step-text">{{ v.text }}</div>
                        </div>
                    </div>
                </div>

                <div class="footer-note">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <circle cx="8" cy="8" r="7" stroke="#0071e3" stroke-width="1.4"/>
                        <path d="M8 4.5v4M8 11h.01" stroke="#0071e3" stroke-width="1.6" stroke-linecap="round"/>
                    </svg>
                    <span>搜狗号码通：发送邮件到 <strong>haomatong_service@sogou-inc.com</strong>（写明需求）</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            processArr: [
                {
                    num: 1,
                    text: '打开手机淘宝客户端（需要将手机淘宝客户端更新至最新版本）'
                },
                {
                    num: 2,
                    text: '点击右下角我的淘宝'
                },
                {
                    num: 3,
                    text: '点击右上角设置'
                },
                {
                    num: 4,
                    text: '点击账户与安全'
                },
                {
                    num: 5,
                    text: '点击最下方的安全中心（蓝色字体）'
                },
                {
                    num: 6,
                    text: '点击中间靠右侧的号码申诉'
                },
                {
                    num: 7,
                    text: '按提示填写相关内容后点击提交即可'
                }
            ]
        };
    }
};
</script>

<style lang="less" scoped>
#unmark {
    height: 100%;
    display: flex;
    flex-direction: column;
    font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
    -webkit-font-smoothing: antialiased;
    color: #1d1d1f;
    line-height: 1.5;
    letter-spacing: -0.01em;
}

.unmark-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.unmark-main {
    flex: 1;
    padding: 32px 40px 40px;
    overflow-y: auto;
    background: #ffffff;
}

.page-header {
    margin-bottom: 40px;
    background: linear-gradient(135deg, rgba(0, 113, 227, 0.04), rgba(0, 113, 227, 0.01));
    border-radius: 12px;
    padding: 28px 32px;
    border-left: 4px solid #0071e3;
    position: relative;
}

.page-header::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 200px;
    height: 100%;
    background: radial-gradient(ellipse at 100% 0%, rgba(0, 113, 227, 0.06), transparent 70%);
    pointer-events: none;
    border-radius: inherit;
}

.eyebrow {
    display: inline-block;
    font-size: 11px;
    font-weight: 600;
    color: white;
    background: #0071e3;
    padding: 3px 10px;
    border-radius: 4px;
    letter-spacing: 0.04em;
    margin-bottom: 16px;
    text-transform: uppercase;
}

.h1-wrap {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
}

.h1-icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    background: linear-gradient(135deg, #0071e3, #0051d5);
    display: grid;
    place-items: center;
    color: white;
    font-size: 20px;
    flex-shrink: 0;
    box-shadow: 0 4px 12px rgba(0, 113, 227, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

h1 {
    font-size: 40px;
    font-weight: 700;
    letter-spacing: -0.025em;
    line-height: 1.1;
    color: #1d1d1f;
    margin: 0;
}

.lede {
    font-size: 17px;
    color: #6e6e73;
    max-width: 640px;
    line-height: 1.5;
    position: relative;
    z-index: 1;
}

.section-title {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 20px;
}

.section-title h2 {
    font-size: 22px;
    font-weight: 600;
    letter-spacing: -0.015em;
    color: #1d1d1f;
}

.section-title .meta {
    font-size: 13px;
    color: #86868b;
}

.providers {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 12px;
    margin-bottom: 56px;
}

.provider {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    padding: 18px;
    display: flex;
    align-items: center;
    gap: 14px;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
    cursor: pointer;
    opacity: 0;
    animation: rise 0.5s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
}

.provider:nth-child(1) { animation-delay: 0.05s; }
.provider:nth-child(2) { animation-delay: 0.10s; }
.provider:nth-child(3) { animation-delay: 0.15s; }
.provider:nth-child(4) { animation-delay: 0.20s; }
.provider:nth-child(5) { animation-delay: 0.25s; }

.provider:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.04);
    border-color: rgba(0, 0, 0, 0.12);
}

.provider-icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: grid;
    place-items: center;
    color: white;
    font-weight: 600;
    font-size: 15px;
    flex-shrink: 0;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.icon-360 { background: linear-gradient(135deg, #00b96b, #008f52); }
.icon-cb { background: linear-gradient(135deg, #007aff, #0051d5); }
.icon-td { background: linear-gradient(135deg, #ff9500, #cc7700); }
.icon-tx { background: linear-gradient(135deg, #1aad19, #128a11); }
.icon-bd { background: linear-gradient(135deg, #2932e1, #1f27a8); }

.provider-info {
    flex: 1;
    min-width: 0;
}

.provider-name {
    font-size: 15px;
    font-weight: 600;
    color: #1d1d1f;
    margin-bottom: 2px;
}

.provider-phone {
    font-size: 13px;
    color: #6e6e73;
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.01em;
}

.provider-link {
    color: #0071e3;
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;
}

.provider-link:hover {
    text-decoration: underline;
}

.featured {
    background: linear-gradient(180deg, #fafafa 0%, #f5f5f7 100%);
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 18px;
    padding: 36px 40px;
    margin-bottom: 32px;
    position: relative;
    overflow: hidden;
}

.featured::before {
    content: "";
    position: absolute;
    top: -40%;
    right: -10%;
    width: 320px;
    height: 320px;
    background: radial-gradient(circle, rgba(255, 149, 0, 0.08), transparent 70%);
    pointer-events: none;
}

.featured-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 8px;
}

.featured-icon {
    width: 52px;
    height: 52px;
    border-radius: 12px;
    background: linear-gradient(135deg, #ff9500, #ff6b00);
    display: grid;
    place-items: center;
    color: white;
    font-size: 22px;
    font-weight: 700;
    box-shadow: 0 6px 20px rgba(255, 107, 0, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.featured-title {
    font-size: 24px;
    font-weight: 600;
    letter-spacing: -0.015em;
    color: #1d1d1f;
}

.featured-subtitle {
    font-size: 14px;
    color: #6e6e73;
    margin-bottom: 28px;
    padding-left: 68px;
}

.steps {
    display: grid;
    gap: 8px;
    position: relative;
}

.step {
    display: grid;
    grid-template-columns: 56px 1fr;
    gap: 16px;
    align-items: center;
    padding: 14px 16px;
    background: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(0, 0, 0, 0.04);
    border-radius: 10px;
    transition: background 0.2s ease, transform 0.2s ease;
    opacity: 0;
    animation: rise 0.5s cubic-bezier(0.2, 0.8, 0.2, 1) forwards;
}

.step:nth-child(1) { animation-delay: 0.30s; }
.step:nth-child(2) { animation-delay: 0.35s; }
.step:nth-child(3) { animation-delay: 0.40s; }
.step:nth-child(4) { animation-delay: 0.45s; }
.step:nth-child(5) { animation-delay: 0.50s; }
.step:nth-child(6) { animation-delay: 0.55s; }
.step:nth-child(7) { animation-delay: 0.60s; }

.step:hover {
    background: rgba(255, 255, 255, 0.95);
    transform: translateX(2px);
}

.step-num {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    font-size: 13px;
    font-weight: 600;
    color: white;
    font-variant-numeric: tabular-nums;
}

.step:nth-child(1) .step-num { background: #007aff; }
.step:nth-child(2) .step-num { background: #5856d6; }
.step:nth-child(3) .step-num { background: #af52de; }
.step:nth-child(4) .step-num { background: #ff2d55; }
.step:nth-child(5) .step-num { background: #ff9500; }
.step:nth-child(6) .step-num { background: #34c759; }
.step:nth-child(7) .step-num { background: #00c7be; }

.step-text {
    font-size: 15px;
    color: #1d1d1f;
    line-height: 1.45;
}

.footer-note {
    margin-top: 40px;
    padding: 16px 20px;
    background: rgba(0, 113, 227, 0.06);
    border-radius: 12px;
    border-left: 3px solid #0071e3;
    font-size: 13px;
    color: #6e6e73;
    display: flex;
    gap: 12px;
    align-items: flex-start;
}

.footer-note svg {
    flex-shrink: 0;
    margin-top: 2px;
}

@keyframes rise {
    from {
        opacity: 0;
        transform: translateY(8px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>